import { Component, Vue } from 'vue-facing-decorator';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Box, Check, Delete, EditPen, CirclePlusFilled } from '@element-plus/icons-vue';
import Header from '@/components/Header/Header.vue';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import Navigation from '@/components/Navigation/Navigation.vue';
import NavigationIndex from "@/models/EnumNavigationIndex";
import ApiService from '@/services/ApiService';
import AuthService from '@/services/AuthService';

@Component(
{
    components:
    {
        Header,
        Breadcrumbs,
        Navigation,
		Box,
		Check,
		EditPen,
		Delete,
		CirclePlusFilled
    },
    enums:
    {
        NavigationIndex
    }
})

export default class Source extends Vue 
{
    private activeName : string = "1";  
    private sourceModelList : SourceModel[] = [];
    private tableData: object[] = [];
    private loading : boolean = true;
    private formValid : boolean = false;
    private hasPermission: boolean[] = [] as boolean[];
    private toDelete : SourceModel | undefined;
    private newSourceModel : SourceModel = {} as SourceModel;
	private currentSource : SourceModel | undefined;
    private windowWidth : number = window.innerWidth;
    private windowHeight : number = window.innerHeight;
    private rules =
    {
        name:
        [
            {
                required: true,
                message: 'Bitte geben Sie eine Bezeichnung ein.',
                trigger: 'blur'
            }
        ]
    };

    public async mounted()
    {
        // get permissions
        await AuthService.getPermissions();
        this.hasPermission['SOUR_SELECT'] = AuthService.hasPermission("SOUR_SELECT");
        this.hasPermission['SOUR_INSERT'] = AuthService.hasPermission("SOUR_INSERT");
        this.hasPermission['SOUR_UPDATE'] = AuthService.hasPermission("SOUR_UPDATE");
        this.hasPermission['SOUR_DELETE'] = AuthService.hasPermission("SOUR_DELETE");


        if (this.hasPermission['SOUR_SELECT'])
        {
            this.loadList();
        }
        
        window.addEventListener('resize', this.onWindowResize);

        this.loading = false;
    }

    private beforeUnmount()
    {
        window.removeEventListener('resize', this.onWindowResize);
    }

	private onWindowResize(e : any)
    {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }

    private async loadList()
    {
        this.loading = true;
        this.sourceModelList = await ApiService.getAllSources() as SourceModel[];
        this.loading = false;
    }

    private async createSource()
    {
        // send new source model via request to API and await
        let source = await ApiService.createSource(this.newSourceModel);

        // check if successful
        if (source)
        {
			ElMessage(
            {
               	message: "Neue Quelle erfolgreich erstellt.",
               	type: 'success',
            });

            this.activeName = "1";
            this.newSourceModel = {} as SourceModel;
            this.formValid = false;
            await this.loadList();
        }
        else
        {
            // or show error message
			ElMessage(
            {
               	message: "Beim Erstellen der neuen Quelle ist ein Fehler aufgetreten.",
               	type: 'error',
            });
        }
    }

    private async updateSource(source : SourceModel)
    {
        let ok : any = await ApiService.updateSource(source);

        if (ok)
        {
			ElMessage(
            {
               	message: "Änderungen wurden übernommen.",
               	type: 'success',
            });
        }
        else
        {
            // or show error message
			ElMessage(
            {
               	message: "Änderungen konnten nicht gespeichert werden.",
               	type: 'error',
            });

        }
    }

    private async deleteSource(source : SourceModel)
    {
        let ok = await ApiService.deleteSource(source);

        if (ok)
        {
			ElMessage(
            {
               	message: "Quelle wurde gelöscht.",
               	type: 'success',
            });
            await this.loadList();
        }
        else
        {
            // or show error message
			ElMessage(
            {
               	message: "Quelle konnte nicht gelöscht werden.",
               	type: 'error',
            });
        }
    }


    private validateForm() : boolean
    {
        if (!this.newSourceModel.name || this.newSourceModel.name.length <= 0) return false;

        return true;
    }

    private onInput()
    {
        this.formValid = this.validateForm();
    }

    private onSourceSaveClick(source : SourceModel)
    {
        this.updateSource(source);
    }

    private onDeleteConfirm(action : string)
    {
        if (this.toDelete && action == 'confirm')
        {
            this.deleteSource(this.toDelete);
        }
    }

    private onSourceDeleteClick(source : SourceModel)
    {
        this.toDelete = source;

        ElMessageBox.confirm('Soll diese Quelle wirklich gelöscht werden?', 'Warning', 
        {
            type: 'warning',
            title: '',
            callback: this.onDeleteConfirm,
            confirmButtonText: 'Löschen',
            cancelButtonText: 'Abbrechen'
        });
    }

    private onNewSourceClick()
    {
        this.createSource();
    }
}
